import * as React from "react"
import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material"
import PaymentsIcon from "@mui/icons-material/Payments"
import TrendingUpIcon from "@mui/icons-material/TrendingUp"
import PaymentsTable from '../Payments/PaymentsTable'
import IndexationsTable from './IndexationsTable'
import PropertySection from './PropertySection'


// ---------------------------------------------------------------------------
// PropertyHistoryCard — "Historique" section of the Location tab.
//
// DECISION: the Paiements/Ré-indexations switch is a ToggleButtonGroup, not
// a second Tabs component. The page already has one level of tabs
// (Location / Bien) above it; stacking a visually identical Tabs inside a
// Location sub-section reads as "tabs within tabs" and blurs which level of
// navigation is being used. A segmented control looks and behaves
// differently enough to read as a filter on this one section, not a second
// page-level choice — which is what it actually is.
//
// DECISION: styled as a small pill (grey track, white selected chip)
// instead of MUI's default outlined ToggleButtonGroup — the default is
// sized for a primary action, and next to a section title it read as
// heavier than the thing it's filtering.
//
// All data loading is delegated to the child components (PaymentsTable and
// IndexationsTable); this component only handles the view switch.
//
// Props
//   supabase    – initialised Supabase client
//   propertyId  – UUID of the property to display
// ---------------------------------------------------------------------------
export default function PropertyHistoryCard({ supabase, propertyId }) {

    const [view, setView] = React.useState('payments')

    return (
        <PropertySection
            title="Historique"
            action={
                <ToggleButtonGroup
                    value={view}
                    exclusive
                    onChange={(_, newValue) => newValue && setView(newValue)}
                    aria-label="Choix de l'historique"
                    sx={{
                        borderRadius: 1.5,
                        p: 0.4,
                        gap: 0.4,
                        '& .MuiToggleButtonGroup-grouped': {
                            border: 0,
                            borderRadius: '8px !important',
                            px: 1.25,
                            py: 0.4,
                            minHeight: 0,
                            fontSize: '0.75rem',
                            textTransform: 'none',
                        },
                        '& .Mui-selected': {
                            bgcolor: 'background.paper !important',
                            color: 'text.primary',
                            boxShadow: '0 1px 2px rgba(0,0,0,0.08)',
                        },
                    }}
                >
                    <ToggleButton value="payments" aria-label="Paiements">
                        <PaymentsIcon sx={{ fontSize: 16, mr: 0.75 }} />
                        Paiements
                    </ToggleButton>
                    <ToggleButton value="indexations" aria-label="Ré-indexations">
                        <TrendingUpIcon sx={{ fontSize: 16, mr: 0.75 }} />
                        Ré-indexations
                    </ToggleButton>
                </ToggleButtonGroup>
            }
        >
            <Box role="tabpanel" hidden={view !== 'payments'}>
                {view === 'payments' && (
                    <PaymentsTable supabase={supabase} propertyId={propertyId} />
                )}
            </Box>

            <Box role="tabpanel" hidden={view !== 'indexations'}>
                {view === 'indexations' && (
                    <IndexationsTable supabase={supabase} propertyId={propertyId} />
                )}
            </Box>

        </PropertySection>
    )
}